import { useQuery } from 'react-query'
import { featureFlagQueryKey, triggerSplitTest } from './helpers'
import { FeatureFlagResponse } from './types'
import { get } from '@fable/api'

const getConfig = async () => await get('/app_config/')

export const useLoadFeatureFlags = () => {
  useQuery([featureFlagQueryKey], () => getConfig(), {
    onSuccess: (data: FeatureFlagResponse) => {
      triggerSplitTest(data)
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 30 * 60 * 1000, // 30 mins
  })
}
